<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19">
        <g fill="none" fill-rule="evenodd">
            <g>
                <g transform="translate(-68 -168) translate(69 169.279)">
                    <ellipse cx="8" cy="8.014" stroke="#2D3E4F" rx="8" ry="8.014"/>
                    <path fill="#2D3E4F" fill-rule="nonzero" d="M8.233 9.546c-.006-.388.026-.658.098-.808.072-.151.256-.35.554-.598.575-.479.95-.857 1.125-1.135.176-.278.263-.572.263-.884 0-.562-.239-1.055-.716-1.479-.478-.423-1.122-.635-1.93-.635-.769 0-1.39.21-1.863.628-.472.418-.727.927-.764 1.526l1.293.161c.09-.418.256-.73.497-.934.24-.204.54-.306.897-.306.37 0 .666.098.885.294.218.195.328.43.328.705 0 .198-.062.378-.186.542-.08.104-.325.323-.736.658s-.685.636-.823.904c-.137.268-.205.61-.205 1.025l.005.336h1.278zm.13 1.898v-1.41H6.956v1.41h1.409z"/>
                </g>
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: 'question-icon'
}
</script>
